<script>
import { mapActions } from 'vuex';
import TableView from '@/components/elements/views/TableView';

export default {
    extends: TableView,

    props: {
        fileId: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            includeHeader: false
        };
    },

    computed: {
        options() {
            return {
                isCard: false,
                addButton: false,
                copyLink: false,
                link: false,
                select: false,
                clickableRows: false
            };
        },

        labels() {
            return [
                { value: 'title', width: '150px' },
                { value: 'details', width: '150px' },
                {
                    value: 'user.fullName',
                    sortFieldName: 'user.firstName',
                    text: 'Author',
                    width: '150px'
                },
                {
                    value: 'likes',
                    type: 'number',
                    width: '150px'
                },
                {
                    value: 'isReported',
                    type: 'boolean',
                    isBadge: true,
                    badgeOptions: {
                        trueVariant: 'danger',
                        falseVariant: 'success'
                    },
                    width: '150px'
                },
                {
                    value: 'createdAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                }
            ];
        },

        additionalFetchData() {
            return {
                id: this.fileId
            };
        }
    },

    methods: {
        ...mapActions({
            getItems: 'files/comments',
            deleteItem: 'comments/destroy'
        })
    }
};
</script>
